import { render, staticRenderFns } from "./EmployeeTypeAddNew.vue?vue&type=template&id=e7aaf882"
import script from "./EmployeeTypeAddNew.vue?vue&type=script&lang=js"
export * from "./EmployeeTypeAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports